import React, { useState } from "react";
import { Nav, NavItem, NavLink, Row, Col } from "reactstrap";
import BasicInfoForm from "./BasicInfoForm";
import BillingInfoForm from "./BillingInfoForm";
import PropTypes from "prop-types";
import StatementConfigForm from "./StatementConfigForm";
const PartnerForm = ({ partnerDetails, handleUpdate }) => {
  const [activeTab, setActiveTab] = useState("1");

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleNext = () => setActiveTab("2");

  return (
    <Row className="w-100">
      <Col md="8">
        <Nav tabs className="mb-4">
          <NavItem className="cursor-pointer">
            <NavLink
              className={activeTab === "1" ? "active" : ""}
              onClick={() => toggleTab("1")}
            >
              Basic Info
            </NavLink>
          </NavItem>
          <NavItem className="cursor-pointer">
            <NavLink
              className={activeTab === "2" ? "active" : ""}
              onClick={() => toggleTab("2")}
            >
              Billing Info
            </NavLink>
          </NavItem>
          <NavItem className="cursor-pointer">
            <NavLink
              className={activeTab === "3" ? "active" : ""}
              onClick={() => toggleTab("3")}
            >
              Statement Config
            </NavLink>
          </NavItem>
        </Nav>

        {activeTab === "1" && (
          <BasicInfoForm
            onNext={handleNext}
            handleUpdate={handleUpdate}
            partnerDetails={partnerDetails}
          />
        )}
        {activeTab === "2" && (
          <BillingInfoForm
            handleUpdate={handleUpdate}
            partnerDetails={partnerDetails}
          />
        )}

        {activeTab === "3" && (
          <StatementConfigForm
            handleUpdate={handleUpdate}
            partnerDetails={partnerDetails}
          />
        )}
      </Col>
    </Row>
  );
};

export default PartnerForm;

PartnerForm.propTypes = {
  partnerDetails: PropTypes.object,
  handleUpdate: PropTypes.func.isRequired,
};
